export { default } from './product-details';
